import PropTypes from 'prop-types';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_VISIBLE_PAGES = 6;
export default function PlaybooksPaginator({
  searchQuery,
  totalCount,
  onPageChange
}) {
  const {
    offset,
    limit
  } = searchQuery;
  const numPages = Math.ceil(totalCount / limit);
  const currentPage = offset / limit + 1;
  return /*#__PURE__*/_jsx(Paginator, {
    maxVisiblePageButtons: MAX_VISIBLE_PAGES,
    page: currentPage,
    pageCount: numPages,
    onPageChange: onPageChange,
    paddingBlockStart: "400"
  });
}
PlaybooksPaginator.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  searchQuery: PropTypes.object.isRequired
};